<template>
 <section v-if="errored">
    <p>We're sorry, we're not able to retrieve this information at the moment, please try back later</p>
  </section>

  <section v-else>
    <div v-if="loading">Loading...</div>
    <div v-else class="quote-of-the-day">
      <blockquote>
        <h1>{{info.q}}</h1>
        <footer><cite>{{info.a}}</cite></footer>
      </blockquote>
      <small class="copyright">
          Inspirational quotes provided by <a href="https://zenquotes.io/" target="_blank">ZenQuotes API</a>
       </small>
    </div>
  </section>
  
</template>


<script>

const API_URL = 'quotes.json';
import axios from 'axios'
//import HelloWorld from './components/HelloWorld.vue'



export default {
  name: 'App',
  data () {
    return {
      info: null,
      random: null,
      loading: true,
      errored: false
    }
  },
  mounted () {
    axios
      .get(API_URL)
      .then(response => {
          this.random = Math.floor(Math.random() * response.data.length);
          this.info = response.data[this.random];
      })
      .catch(error => {
          // eslint-disable-next-line no-console
          console.log(error)
          this.errored = true
      })
      .finally(() => this.loading = false)
  }
}
</script>

<style>
html, body, section {
  height:100%;
  padding: 0;
  margin: 0;
}
.quote-of-the-day {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height:100%;
  display: flex;
  flex-direction: column;
}
blockquote {
	width: 60%;
	margin-left: auto;
	margin-right: auto;
	flex: 1 0 auto;
	display: flex;
	flex-direction: column;
	justify-content: center;
	margin-bottom:60px;
}
blockquote h1 {
	font-style: italic;
	font-size: 3rem;
	font-size: 3vmax;
}
.copyright {
	text-align: right;
	padding: 12px 16px;
}
</style>
